import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { TimeProvider } from './time.provider';
import { EventCard } from './card/event.card';
import { Timeline } from './timeline/event.timeline';
import { CommonModule } from '@angular/common';
import { ToolsModule } from '../tools/tools.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImportMaterialModule } from '../material.module';

// import { createCustomElement } from '@angular/elements';
import { MonthCalendar } from './calendar/month.calendar';
import { EventForm } from './form/event.form';
// import { AngularEditorModule } from '@kolkov/angular-editor';
import { EventViewer } from './viewer/event.viewer';
import { EventSelector } from './selector/event.selector';


@NgModule({
    declarations: [
        EventCard, EventForm,
        Timeline, EventSelector,
        MonthCalendar,
        EventViewer
    ],
    imports: [
        CommonModule,
        FormsModule, ReactiveFormsModule,
        ToolsModule,
        ImportMaterialModule,
        // AngularEditorModule
    ],
    exports: [
        EventCard, EventForm,
        Timeline, EventSelector,
        MonthCalendar,
        EventViewer
    ],
    providers: [
        TimeProvider
    ],
    entryComponents: [
        EventCard, EventForm,
        Timeline, EventSelector,
        MonthCalendar,
        EventViewer
    ]
})
export class TimeModule {

    // constructor(private injector: Injector) {
    //     const explorer = createCustomElement(FileExplorer, {injector: this.injector});
    
    //     customElements.define('ess-file-explorer', explorer);
    //     console.log("Registered element (with distinct selector!!!!!!) " + "ess-file-explorer");

    // }
}